import apiConfig from 'http/services/api.config'
import apiService from 'http/services/api.service'
import { ApiResponse } from 'http/types/api-response'
import { StreamHealthResponse } from '../types/camera-health.types'

class CameraHealthApiService {
  private readonly baseUrl: string

  constructor() {
    this.baseUrl = apiConfig.endpoints.cameras
  }

  public async getCameraHealth(
    clientId: string
  ): Promise<ApiResponse<StreamHealthResponse>> {
    return apiService.get<ApiResponse<StreamHealthResponse>>(
      `${this.baseUrl}/${clientId}/health`
    )
  }
}

export const cameraHealthApiService = new CameraHealthApiService()
export default cameraHealthApiService
